import React, { useState, useRef, useEffect } from "react";

function TreasureExtraModal({ open, onSubmit, onCancel }) {
  const [photo, setPhoto] = useState(null);
  const [desc, setDesc] = useState("");
  const fileInputRef = useRef();

  // 每次 open 變 true 時清空欄位
  useEffect(() => {
    if (open) {
      setPhoto(null);
      setDesc("");
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  }, [open]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-sm flex flex-col gap-4">
        <h2 className="text-xl font-bold text-amber-700 mb-2">藏寶附加資訊</h2>
        <label className="block mb-2 font-medium text-gray-700">
          上傳照片（選填）
        </label>
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          onChange={(e) => setPhoto(e.target.files[0])}
          className="mb-2"
        />
        {photo && (
          <img
            src={URL.createObjectURL(photo)}
            alt="預覽"
            className="w-full h-32 object-cover rounded mb-2"
          />
        )}
        <label className="block mb-2 font-medium text-gray-700">
          描述（選填）
        </label>
        <textarea
          value={desc}
          onChange={(e) => setDesc(e.target.value)}
          rows={3}
          className="w-full border rounded p-2 mb-2"
          placeholder="可輸入提示、故事或其他描述..."
        />
        <div className="flex gap-3 mt-2">
          <button
            className="flex-1 py-2 rounded-xl bg-amber-400 text-neutral-900 font-bold shadow hover:bg-amber-500 transition text-lg"
            onClick={() => onSubmit(photo, desc)}
          >
            送出
          </button>
          <button
            className="flex-1 py-2 rounded-xl bg-neutral-300 text-gray-700 font-bold shadow hover:bg-neutral-400 transition text-lg"
            onClick={onCancel}
          >
            取消
          </button>
        </div>
      </div>
    </div>
  );
}

export default TreasureExtraModal;
